import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { PrismCard, PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import HotelBenchmarkInsightCompetitorsTableCompetitors from 'lumen/components/hotel/benchmark-insight/competitors/table-competitors';
import type { BenchmarkInsightCompetitorsProposedCompset } from 'lumen/models';

interface HotelBenchmarkInsightCompetitorsCompsetCardProposedCompsetSignature {
  Args: {
    index: number;
    isSelected: boolean;
    onClickCard: () => void;
    proposedCompset: BenchmarkInsightCompetitorsProposedCompset;
  };
  Blocks: {
    default: [];
  };
}

export default class HotelBenchmarkInsightCompetitorsCompsetCardProposedCompset extends Component<HotelBenchmarkInsightCompetitorsCompsetCardProposedCompsetSignature> {
  get compsetNumber(): string {
    const { index } = this.args;

    return String(index + 1);
  }

  <template>
    <PrismCard
      @isSecondary={{true}}
      class="prism-card--with-border cursor-pointer
        {{if @isSelected 'prism-card--selected'}}"
      {{on "click" @onClickCard}}
    >
      <:header as |Header|>
        <div class="flex flex-row items-center px-100">
          {{yield}}

          <div class="flex flex-row items-center gap-100">
            <PrismIcon @name={{@proposedCompset.icon}} />

            <Header.title>
              {{t
                "settings.competitors.benchmark.compset.builder.proposals.compset_name"
                compsetName=@proposedCompset.name
                compsetNumber=this.compsetNumber
              }}
            </Header.title>
          </div>
        </div>
      </:header>

      <:content>
        <div class="px-100 pb-100">
          <HotelBenchmarkInsightCompetitorsTableCompetitors
            @competitors={{@proposedCompset.compset}}
            @compsetPrioritizedCategory={{@proposedCompset.prioritizedCategory}}
            @isLoading={{false}}
            @isReadOnly={{true}}
            @isRowHoverDisabled={{true}}
            @showSuggestedCompetitorInfo={{true}}
          />
        </div>
      </:content>
    </PrismCard>
  </template>
}
